"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWaiter = exports.anyWaiting = exports.isWaiting = exports.createActionCRUDResources = exports.createActionResources = void 0;

var _reduxAct = require("redux-act");

var _effects = require("redux-saga/effects");

var _reselect = require("reselect");

var _reactRedux = require("react-redux");

var id = 0;

var createActionResources = function createActionResources(actionName) {
  id += 1;
  var actionNameReplace = "[".concat(id, "] ").concat(actionName);
  var start = (0, _reduxAct.createAction)(actionNameReplace);
  var success = (0, _reduxAct.createAction)("".concat(start, "/success/@@end"));
  var error = (0, _reduxAct.createAction)("".concat(start, "/error/@@end"));
  return {
    id: start.toString(),
    start: start,
    success: success,
    error: error,
    waiterAction: function waiterAction(callback) {
      return {
        type: start,
        callback: callback
      };
    },
    waiterActionForSaga: function waiterActionForSaga(handler) {
      return /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!action.continue) {
                  _context.next = 3;
                  break;
                }

                return _context.delegateYield(handler(action), "t0", 2);

              case 2:
                return _context.abrupt("return", _context.t0);

              case 3:
                _context.next = 5;
                return (0, _effects.put)({
                  type: start,
                  callback: handler,
                  action: action
                });

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      });
    }
  };
};

exports.createActionResources = createActionResources;

var createActionCRUDResources = function createActionCRUDResources(actionName) {
  return {
    fetch: createActionResources("fetch ".concat(actionName)),
    create: createActionResources("create ".concat(actionName)),
    update: createActionResources("update ".concat(actionName)),
    delete: createActionResources("delete ".concat(actionName))
  };
};

exports.createActionCRUDResources = createActionCRUDResources;

var waiterSelector = function waiterSelector(state) {
  return state.waiters;
};

var isWaiting = function isWaiting(waiter) {
  return (0, _reselect.createSelector)(waiterSelector, function (waiters) {
    return waiters.includes(waiter);
  });
};

exports.isWaiting = isWaiting;
var anyWaiting = (0, _reselect.createSelector)(waiterSelector, function (waiters) {
  return waiters.length > 0;
});
exports.anyWaiting = anyWaiting;

var useWaiter = function useWaiter(selectorFunc) {
  var waiting = (0, _reactRedux.useSelector)(function (state) {
    return selectorFunc(state.waiter);
  });
  return [waiting];
};

exports.useWaiter = useWaiter;